// import the library
import { library } from '@fortawesome/fontawesome-svg-core'

// import your icons
import {
  faAddressCard,
  faArrowDown,
  faArrowUp,
  faAt,
  faBackward,
  faBackwardFast,
  faBars,
  faBasketShopping,
  faBook,
  faBookOpenReader,
  faBuildingShield,
  faCheck,
  faDiagramProject,
  faDollarSign,
  faEdit,
  faExclamationCircle,
  faEllipsisVertical,
  faForward,
  faForwardFast,
  faFileContract,
  faFileCsv,
  faFileInvoiceDollar,
  faFilePdf,
  faGear,
  faInfoCircle,
  faKey,
  faLock,
  faNewspaper,
  faPencil,
  faPenToSquare,
  faPeopleArrows,
  faPlus,
  faRotate,
  faServer,
  faTrashCan,
  faTruckFast,
  faArrowTurnDown,
  faArrowTurnUp,
  faUser,
  faUserCircle,
  faUserGraduate,
  faUserLock,
  faUsersGear,
  faXmark,
} from '@fortawesome/free-solid-svg-icons'

library.add(
  faAddressCard,
  faArrowDown,
  faArrowUp,
  faAt,
  faBackward,
  faBackwardFast,
  faBars,
  faBasketShopping,
  faBookOpenReader,
  faBook,
  faBuildingShield,
  faCheck,
  faDiagramProject,
  faDollarSign,
  faEdit,
  faExclamationCircle,
  faEllipsisVertical,
  faFileContract,
  faFileCsv,
  faFileInvoiceDollar,
  faFilePdf,
  faForward,
  faForwardFast,
  faGear,
  faKey,
  faInfoCircle,
  faLock,
  faNewspaper,
  faPencil,
  faPenToSquare,
  faPeopleArrows,
  faPlus,
  faRotate,
  faServer,
  faTrashCan,
  faTruckFast,
  faArrowTurnDown,
  faArrowTurnUp,
  faUser,
  faUserCircle,
  faUserGraduate,
  faUserLock,
  faUsersGear,
  faXmark
)
